export default {
    HEADER: "История",
    BALANCE_BEFORE: "Баланс до запроса",
    FILTER_PLACEHOLDER: "Поиск",
    POINTS_LEFT_BEFORE_REQUEST: "Баланс до списания",
    POINTS_WRITTEN_OFF: "Списано",
    POINTS_LEFT_AFTER_REQUEST: "Баланс после списания списания",
    DURATION: "Длительность",
    CREATED_DATE: "Дата выполнения",
    CREATED_TIME: "Время выполнения",
    ENDPOINT: "Метод"
};
